import { Box, Heading, Stack } from 'braid-design-system';
import { useEffect, useState } from 'react';

import { FollowButton } from 'src/components/atoms/Buttons';
import ThreadCard from 'src/components/molecules/Shared/ThreadCard/ThreadCard';
import { handleAuthCheck } from 'src/core/utils/authUtil';
import { useAnalytics } from 'src/provider/analytics';
import { useAuthStatus } from 'src/provider/auth';
import { useGroupThreads } from 'src/provider/groupThreads';
import { useLoginModal } from 'src/provider/loginModal';
import {
  type updateFollowCategoryStatusParams,
  updateFollowCategoryStatus,
} from 'src/services/categoriesService';

export default () => {
  const {
    groupThreadsState: { groupThreads, followStatus: isFollowed },
  } = useGroupThreads();
  const { trackAnalyticsInteraction } = useAnalytics();
  const { authStatus } = useAuthStatus();
  const { openLoginDialog } = useLoginModal();

  const [followStatus, setFollowStatus] = useState(isFollowed);
  useEffect(() => {
    setFollowStatus(isFollowed);
  }, [isFollowed]);

  if (!groupThreads) return null;

  const { category, threads } = groupThreads;
  const { groupId, name: categoryName } = category;

  const toggleFollowStatus = async () => {
    if (
      !handleAuthCheck({
        authStatus,
        openLoginDialog,
        trackAnalyticsInteraction,
      })
    )
      return;

    try {
      const params: updateFollowCategoryStatusParams = {
        groupId,
        followed: !followStatus,
      };
      await updateFollowCategoryStatus(params);
      setFollowStatus(!followStatus);
      trackAnalyticsInteraction('FollowGroupClick', {
        groupId,
        groupName: categoryName,
        linkAction: followStatus ? 'unfollow' : 'follow',
        linkPosition: 'group',
      });
    } catch (error) {
      // Ignore errors
    }
  };

  return (
    <Box display="flex" flexDirection="column">
      <Box
        paddingBottom="large"
        paddingTop="xxsmall"
        display="flex"
        justifyContent="spaceBetween"
        alignItems="center"
        gap="small"
      >
        <Heading level="3" weight="regular">
          {categoryName}
        </Heading>
        <FollowButton
          followStatus={followStatus}
          onClick={toggleFollowStatus}
        />
      </Box>
      <Stack space="medium">
        {threads.map((thread) => (
          <ThreadCard key={thread.id} thread={{ ...thread, category }} />
        ))}
      </Stack>
    </Box>
  );
};
